import { render, staticRenderFns } from "./producttype.vue?vue&type=template&id=5402dbe3&"
import script from "./producttype.vue?vue&type=script&lang=js&"
export * from "./producttype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports